import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BaseProvider } from 'src/app/core/services/base-provider';
import { GlobalsService } from 'src/app/core/services/globals.service';
import { LsHelperService } from 'src/app/core/services/ls-helper.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./globals.service";
import * as i3 from "@angular/common/http";
import * as i4 from "./ls-helper.service";
export class MainSearchService extends BaseProvider {
    constructor(router, globals, http, ls) {
        super();
        this.router = router;
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.mainSearchIsVisible = false;
        this.isSearchingFromHome = false;
        this.isSearching = false;
        this.pages = 0;
        this.totalFound = 0;
        this.baseUrl = "mainSearch";
    }
    search(params) {
        if (params.term == "")
            return;
        this.isSearching = true;
        this.term = params.term;
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl +
                '/page/' + this.page +
                '/size/50' +
                '?term=' + params.term;
            this.http
                .get(this.url)
                .subscribe((data) => {
                this.isSearching = false;
                this.list = data.Data;
                this.pages = 0;
                this.totalFound = 0;
                if (this.list.length > 0) {
                    this.totalFound = this.list[0].TotalRows;
                    this.pages = this.list[0].TotalPages;
                }
                resolve(data.Data);
            }, err => {
                this.isSearching = false;
                reject(err);
            });
        });
    }
    gotoUrl(item) {
        var url = "";
        this.clearSearch();
        if (item.ParentCategoryId) {
            url = "/transaction-type/" + item.Id;
        }
        else {
            url = "/sub/" + item.CategoryId;
        }
        this.router.navigate([url]);
    }
    clearSearch() {
        this.mainSearchIsVisible = false;
        this.list = [];
    }
}
MainSearchService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MainSearchService_Factory() { return new MainSearchService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.GlobalsService), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LsHelperService)); }, token: MainSearchService, providedIn: "root" });
